import { render, staticRenderFns } from "./MasterMerkBarang.vue?vue&type=template&id=5f5c7063&"
import script from "./MasterMerkBarang.vue?vue&type=script&lang=js&"
export * from "./MasterMerkBarang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports